<template>
	<div class="one-menu">
		<vue-particles v-if="show" color="#dedede" :particleOpacity="0.7" :particlesNumber="80" shapeType="circle"
		 :particleSize="4" linesColor="#dedede" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150"
		 :moveSpeed="4" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
		</vue-particles>
		<div class="menu-wrapper animated zoomIn">
			<div class="select-type" v-for="(data, index) in firstMenu" :key="index" @click="toSecondMenu(data.path)">{{data.title}}</div>
		</div>
		<transition name="fade">
			<div class="alert-box" v-if="showChange">
				<div class="alert-content" style="width: auto">
					<div class="alert-content-title">修改密码</div>
					<div class="input-contain" style="margin: 0.5vw 0">
						<div class="input-title" style="padding-left: 1.78vw">旧密码：</div>
						<div class="input-wrapper">
							<input type="password" placeholder="" v-model="changeData.oldPassword" />
						</div>
					</div>
					<div class="input-contain" style="margin: 0.5vw 0">
						<div class="input-title" style="padding-left: 1.78vw">新密码：</div>
						<div class="input-wrapper">
							<input type="password" placeholder="" v-model="changeData.newPassword" />
						</div>
					</div>
					<div class="input-contain" style="margin: 0.5vw 0 1vw 0">
						<div class="input-title">确认新密码：</div>
						<div class="input-wrapper">
							<input type="password" placeholder="" v-model="changeData.confirmNewPassword" />
						</div>
					</div>
					<div class="alert-content-btn">
						<div class="btn-cancel button" @click="cancelChange">取消</div>
						<div class="btn-confirm button" @click="confirmChange">确认</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import {
		noEmpty
	} from '../../tools/methods'
	import {
		updateUserPassword
	} from '../../api/login'
	import AES from '../../tools/AES'

	export default {
		name: 'OneMenu',
		data() {
			return {
				show: false,
				firstMenu: [{
						title: '智慧养护',
						path: '/maintenance'
					},
					{
						title: '基础管理',
						path: '/management'
					},
					{
						title: '系统管理',
						path: '/system/department'
					}
				],
				showChange: false,
				changeData: {
					oldPassword: '',
					newPassword: '',
					confirmNewPassword: ''
				}
			}
		},
		created() {
			let uid = window.location.href
			uid = uid.split('#')[0].split('/')
			uid = uid[uid.length - 1]
			let n = window.location.href.replace(uid + '#', '#')
			location.href = n
			let that = this
			setTimeout(function() {
				that.show = true
			}, 500)
			if (this.$route.query.code === 913) {
				this.showChange = true
			}
		},
		methods: {
			toSecondMenu: function(path) {
				this.$router.push({
					path: path
				})
			},
			confirmChange: function() {
				if (
					noEmpty(this.changeData.oldPassword, '请输入旧密码', 'login-message') &&
					noEmpty(this.changeData.newPassword, '请输入新密码', 'login-message') &&
					noEmpty(this.changeData.confirmNewPassword, '请输入确认新密码', 'login-message')
				) {
					if (this.changeData.newPassword !== this.changeData.confirmNewPassword) {
						this.$message({
							message: '新密码与确认新密码不一致!',
							type: 'warning',
							center: 'true',
							customClass: 'login-message',
							duration: '1000'
						})
					} else {
						let body = {
							oldPassword: AES.encrypt(this.changeData.oldPassword, 'onWwdDEUMfBKC1zl'),
							newPassword: AES.encrypt(this.changeData.newPassword, 'onWwdDEUMfBKC1zl')
						}
						updateUserPassword(body).then(res => {
							console.log(res)
							this.showChange = false
							this.changeData = {
								oldPassword: '',
								newPassword: '',
								confirmNewPassword: ''
							}
							this.$message({
								message: '修改成功!',
								type: 'success',
								center: 'true',
								customClass: 'login-message',
								duration: '1000'
							})
						}).catch(err => {
							console.log(err)
						})
					}
				}
			},
			cancelChange: function() {
				this.showChange = false
				this.changeData = {
					oldPassword: '',
					newPassword: '',
					confirmNewPassword: ''
				}
			}
		}
	}
</script>

<style scoped>
	.one-menu {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		background: url("../../assets/first_menu_bg.jpg") no-repeat center;
		background-size: 100% 100%;
	}

	.menu-wrapper {
		display: flex;
	}

	.select-type {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		cursor: pointer;
		font-size: 1.5vw;
		transition: all 0.3s ease-in;
		color: #ffffff;
		background: url("../../assets/box-4-before.png") no-repeat center;
		background-size: cover;
		width: 10vw;
		height: 10vw;
		margin: 0 2vw;
	}

	.select-type:hover {
		color: #00fff0;
		background: url("../../assets/box-4-after.png") no-repeat center;
		width: 10vw;
		height: 10vw;
		background-size: cover;
		transform: scale(1.3);
	}

	#particles-js {
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
	}
</style>



// WEBPACK FOOTER //
// src/page/oneMenu/OneMenu.vue